import { useCallback, useEffect, useState } from "react";
import _ from "lodash";

/**
 * Return scroll offsets when scrolling in an element.
 * @param {HTMLElement | Window} rootElement - the root element to check scroll of.
 * @return {{ top: number, left: number }} scroll offsets.
 */
export const useScroll = (rootElement: Element | Window = window): { top: number; left: number } => {
    const [offsets, setOffsets] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

    const handleScroll = useCallback(
        (event: Event) =>
            setOffsets({
                top: _.get(event, "currentTarget.scrollTop", window.pageYOffset),
                left: _.get(event, "currentTarget.scrollLeft", window.pageXOffset),
            }),
        []
    );

    useEffect(() => {
        rootElement.addEventListener("scroll", handleScroll);
        return () => rootElement.removeEventListener("scroll", handleScroll);
    }, [rootElement, handleScroll]);

    return offsets;
};
